<template>
  <div>
    <!-- <div style="margin-bottom: 10px">
      <a-input-group compact>
        <a-dropdown :disabled="!insertNum">
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item v-for="(item, index) in topicTypeArr" :key="index">
              <a-icon type="user" />{{ item.label }}
            </a-menu-item>
          </a-menu>
          <a-button icon="plus">插入题目</a-button>
        </a-dropdown>
        <a-input-number v-model="insertNum" style="width: 150px" :min="1" />
      </a-input-group>
    </div> -->

    <a-table
      :columns="columns"
      :data-source="tableData"
      bordered
      :pagination="pagination"
      :scroll="{ y: 500 }"
    >
      <template slot="name" slot-scope="text">
        <a>{{ text }}</a>
      </template>
      <!-- <template slot="title" slot-scope="currentPageData"> Header </template>
    <template slot="footer" slot-scope="currentPageData"> Footer </template> -->
    </a-table>
  </div>
</template>
<script>
import { postAction, deleteAction } from '@api/manage'

export default {
  name: 'QuestionTable',
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      topicTypeArr: [
        { label: '判断题', type: 'Judgment' },
        { label: '单选题', type: 'SingleChoice' },
        { label: '多选题', type: 'MultipleChoice' },
        { label: '简答题', type: 'ShortAnswer' },
      ],
      insertNum: '',
      pagination: {
        // current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        // showQuickJumper: true,
        showSizeChanger: true,
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: '题目',
          dataIndex: 'name',
          align: 'center',
          customRender: (_, record) => {
            return (
              <a-tooltip placement="top">
                {record.name.length >= 40 && <template slot="title">{record.name}</template>}
                <span>
                  {record.name.length >= 40 ? record.name.substring(0, 40) + '...' : record.name}
                </span>
              </a-tooltip>
            )
          },
        },
        // {
        //   title: '试题类型',
        //   dataIndex: 'topicType',
        //   align: 'center',
        //   customRender: (_, record) => {
        //     const currObj = this.topicTypeArr.find((item) => item.type === record.topicType)
        //     return currObj.label || '未知'
        //   },
        // },
        // {
        //   title: '试题内容',
        //   dataIndex: 'topic',
        //   align: 'center',
        //   customRender: (_, record) => {
        //     return record.topic.length >= 40 ? (
        //       <a-tooltip placement="top">
        //         <template slot="title">{record.topic}</template>
        //         <span>{record.topic.substring(0, 40) + '...'}</span>
        //       </a-tooltip>
        //     ) : (
        //       record.topic
        //     )
        //   },
        // },
        // {
        //   title: '关联项',
        //   className: 'relevance',
        //   dataIndex: 'relevance',
        //   align: 'center',
        //   customRender: (_, record) => {
        //     return record.relevance.map((item) => {
        //       return <a-tag>{item}</a-tag>
        //     })
        //   },
        // },
        // {
        //   title: '选项内容',
        //   dataIndex: 'topicOptions',
        //   align: 'center',
        //   customRender: (_, record) => {
        //     return record.topicOptions.map((item) => {
        //       return (
        //         <a-tag>
        //           {item.key}-{item.value}
        //         </a-tag>
        //       )
        //     })
        //   },
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          customRender: (_, record) => {
            return (
              <div style="cursor: pointer">
                <span style="color: #1890FF" onClick={() => this.editTopic(record)}>
                  编辑
                </span>
                <a-divider type="vertical" />
                <a-popconfirm
                  title="确定要删除该题目吗？"
                  ok-text="是"
                  cancel-text="否"
                  onConfirm={() => this.deleteTopic(record)}
                  onCancel={() => {}}
                >
                  <span style="color: #f81d22">删除</span>
                </a-popconfirm>
              </div>
            )
          },
        },
      ],
      // customRow: (record) => {
      //   return {
      //     on: {
      //       click: () => {
      //         // this.$emit('editForm', record)
      //       },
      //     },
      //   }
      // },
      tableData: [],
    }
  },
  created() {
    // this.getQuesList()
  },
  watch: {
    dataSource: {
      handler(newVal, oldVal) {
        console.log('列表数据：', newVal)

        this.tableData = newVal
      },
      deep: true,
    },
  },
  methods: {
    getQuesList() {
      const quesTableList = JSON.parse(localStorage.getItem('quesTableList')).map(
        (item, index) => ({
          ...item,
          index: index + 1,
        })
      )
      // console.log('列表数据：', quesTableList);
      this.tableData = quesTableList
    },
    editTopic(record) {
      const params = {}
      this.$emit('editForm', record)
    },
    deleteTopic(record) {
      deleteAction('/schoolEvaluationQuestion/delete', { id: record.id }).then((res) => {
        if (res.success) {
          this.$message.success('删除成功')
          this.$emit('refreshData')
        }
      })
    },
    handleMenuClick(e) {
      console.log('插入题目', this.topicTypeArr[e.key], '序号', this.insertNum)
      this.$emit('insertionForm', this.topicTypeArr[e.key], this.insertNum)
    },
  },
}
</script>
<style>
th.column-money,
td.column-money {
  text-align: right !important;
}
</style>
